import _ from 'lodash';
import {actions} from './modules/auth/actions';

const isProd = process.env.NODE_ENV === 'production';

export default function setupAxios(axios, store) {
  axios.interceptors.request.use(
    config => {
      const {
        auth: { authToken }
      } = store.getState();

      config.baseURL = isProd ? 'https://api.lullu.app' : 'http://15.165.108.239:9000';
      config.headers['x-ssp-channel'] = '03';
      config.headers['Access-Control-Expose-Headers'] = 'x-ssp-token';

      if (authToken) {
        config.headers['x-ssp-token'] = authToken;
      }
      return config;
    },
    err => Promise.reject(err)
  );

  axios.interceptors.response.use(response => {
    if (response.headers) {
      const {dispatch} = store;
      const token = response.headers['x-ssp-token'];
      dispatch(actions.refreshToken(token));
    }
    return _.get(response, 'data.data');
  }, function (error) {
    const {dispatch} = store;
    const status = error.response.status;
    const _error = _.get(error, 'response.data', error);
    if (status === 401) {
      alert(_error.message);
      dispatch(actions.logout());
    }
    return Promise.reject(_error);
  });
}
